
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 4v16h16V4H4zm5 12.5c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1zm0-4c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1zm0-4c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1zm8 8c0 .28-.1.5-.21.5h-5.57c-.12 0-.21-.22-.21-.5v-1c0-.28.1-.5.21-.5h5.57c.12 0 .21.22.21.5v1zm0-4c0 .28-.1.5-.21.5h-5.57c-.12 0-.21-.22-.21-.5v-1c0-.28.1-.5.21-.5h5.57c.12 0 .21.22.21.5v1zm0-4c0 .28-.1.5-.21.5h-5.57c-.12 0-.21-.22-.21-.5v-1c0-.28.1-.5.21-.5h5.57c.12 0 .21.22.21.5v1z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 18V4c0-1.1.9-2 2-2h11c0-1.1-.9-2-2-2H4C1.79 0 0 1.79 0 4v12c0 1.1.9 2 2 2z"}})])
          )
        }
      }
    